module.exports = __webpack_public_path__ + "maiyee/img/gdbf.21240b78.svg";